import { useSiteStore } from '~/stores/site.store';
import { defaultRedirects } from 'assets/data/config';

export default defineNuxtRouteMiddleware((to) => {
  const siteStore = useSiteStore();

  const redirects = [...siteStore.getRedirects, ...defaultRedirects];
  const isRedirectAvailable = redirects.find((k) => k?.fromLink === to.path);

  if (!!isRedirectAvailable)
    return navigateTo(
      {
        path: isRedirectAvailable?.toLink,
        query: to.query,
      },
      { redirectCode: 301, replace: true },
    );
});
